import './App.css'
import { StrictMode } from 'react';
import { AppRoutes } from './routes';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { Error404 } from './components/page-errors/Error404'
import 'bootstrap-icons/font/bootstrap-icons.css';

function App() {
    const queryClient = new QueryClient();

    return (
        <StrictMode>
            <ErrorBoundary fallback={<Error404 />}>
                <QueryClientProvider client={queryClient}>
                    <BrowserRouter>
                        <AppRoutes />
                    </BrowserRouter>
                </QueryClientProvider>
            </ErrorBoundary>
        </StrictMode>
    )
}

export default App
